 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { SUPPORTED_LANGUAGE_CODES } from "./language";
import sessionExpiryResources from "./session_expiry_resources";

const isPlainObject = (value) =>
    value !== null && typeof value === "object" && !Array.isArray(value);

const mergeTranslationObjects = (...objects) =>
    objects.reduce((merged, object) => {
        Object.entries(object || {}).forEach(([key, value]) => {
            if (isPlainObject(value) && isPlainObject(merged[key])) {
                merged[key] = mergeTranslationObjects(merged[key], value);
                return;
            }

            merged[key] = value;
        });

        return merged;
    }, {});

export const mergeI18nResources = (...resourceSets) =>
    SUPPORTED_LANGUAGE_CODES.reduce((mergedResources, language) => {
        mergedResources[language] = {
            translation: mergeTranslationObjects(
                ...resourceSets.map(
                    (resources) => _optionalChain([resources, 'optionalAccess', _ => _[language], 'optionalAccess', _2 => _2.translation]) || {}
                )
            ),
        };

        return mergedResources;
    }, {});

const commonResources = {
    th: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "การศึกษายืดหยุ่นตอบโจทย์ชีวิต",
                contactUs: "ติดต่อเรา",
                contactEmail: "อีเมล {{email}}",
                home: "หน้าหลัก",
                schoolInformation: "OBEC Zero Dropout",
                language: "ภาษา",
                changeLanguage: "เปลี่ยนภาษา",
                aiHub: "AI Hub",
                moocHub: "MOOC Hub",
                closeAiHub: "ปิด AI Hub",
                opensNewTab: "เปิดในแท็บใหม่",
                languages: {
                    th: "ไทย",
                    en: "อังกฤษ",
                    my: "พม่า",
                    lo: "ลาว",
                    id: "อินโดนีเซีย",
                    ms: "มาเลย์",
                },
            },
            search: {
                placeholder: "ค้นหา...",
                usageCount: "{{count}} ครั้ง",
                user: "ผู้ใช้งาน",
                group: "กลุ่ม",
            },
            footer: {
                title: "Mobile School การศึกษายืดหยุ่นตอบโจทย์ชีวิต",
                organization: "กองทุนเพื่อความเสมอภาคทางการศึกษา",
            },
        },
    },
    en: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "Flexible learning for real life",
                contactUs: "Contact us",
                contactEmail: "Email {{email}}",
                home: "Home",
                schoolInformation: "OBEC Zero Dropout",
                language: "Language",
                changeLanguage: "Change language",
                aiHub: "AI Hub",
                moocHub: "MOOC Hub",
                closeAiHub: "Close AI Hub",
                opensNewTab: "opens in a new tab",
                languages: {
                    th: "Thai",
                    en: "English",
                    my: "Burmese",
                    lo: "Lao",
                    id: "Indonesian",
                    ms: "Malay",
                },
            },
            search: {
                placeholder: "Search...",
                usageCount: "{{count}} times",
                user: "User",
                group: "Group",
            },
            footer: {
                title: "Mobile School Flexible learning for real life",
                organization: "Equitable Education Fund",
            },
        },
    },
    id: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "Pembelajaran fleksibel untuk kehidupan nyata",
                contactUs: "Hubungi kami",
                contactEmail: "Email {{email}}",
                home: "Beranda",
                schoolInformation: "OBEC Zero Dropout",
                language: "Bahasa",
                changeLanguage: "Ubah bahasa",
                aiHub: "AI Hub",
                moocHub: "MOOC Hub",
                closeAiHub: "Tutup AI Hub",
                opensNewTab: "terbuka di tab baru",
                languages: {
                    th: "Thai",
                    en: "Inggris",
                    my: "Burma",
                    lo: "Lao",
                    id: "Indonesia",
                    ms: "Melayu",
                },
            },
            search: {
                placeholder: "Cari...",
                usageCount: "{{count}} kali",
                user: "Pengguna",
                group: "Grup",
            },
            footer: {
                title: "Mobile School Pembelajaran fleksibel untuk kehidupan nyata",
                organization: "Dana Pendidikan yang Setara",
            },
        },
    },
    ms: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "Pembelajaran fleksibel untuk kehidupan sebenar",
                contactUs: "Hubungi kami",
                contactEmail: "E-mel {{email}}",
                home: "Laman utama",
                schoolInformation: "OBEC Zero Dropout",
                language: "Bahasa",
                changeLanguage: "Tukar bahasa",
                aiHub: "AI Hub",
                moocHub: "MOOC Hub",
                closeAiHub: "Tutup AI Hub",
                opensNewTab: "dibuka dalam tab baharu",
                languages: {
                    th: "Thai",
                    en: "Inggeris",
                    my: "Burma",
                    lo: "Lao",
                    id: "Indonesia",
                    ms: "Melayu",
                },
            },
            search: {
                placeholder: "Cari...",
                usageCount: "{{count}} kali",
                user: "Pengguna",
                group: "Kumpulan",
            },
            footer: {
                title: "Mobile School Pembelajaran fleksibel untuk kehidupan sebenar",
                organization: "Dana Pendidikan Saksama",
            },
        },
    },
    my: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "ဘဝနှင့်ကိုက်ညီသော ပျော့ပြောင်းသင်ယူမှု",
                contactUs: "ဆက်သွယ်ရန်",
                contactEmail: "အီးမေးလ် {{email}}",
                home: "ပင်မစာမျက်နှာ",
                schoolInformation: "OBEC Zero Dropout",
                language: "ဘာသာစကား",
                changeLanguage: "ဘာသာစကားပြောင်းရန်",
                aiHub: "AI Hub",
                moocHub: "MOOC Hub",
                closeAiHub: "AI Hub ကို ပိတ်ရန်",
                opensNewTab: "တက်ဘ်အသစ်တွင် ဖွင့်မည်",
                languages: {
                    th: "ထိုင်း",
                    en: "အင်္ဂလိပ်",
                    my: "မြန်မာ",
                    lo: "လာအို",
                    id: "အင်ဒိုနီးရှား",
                    ms: "မလေး",
                },
            },
            search: {
                placeholder: "ရှာရန်...",
                usageCount: "{{count}} ကြိမ်",
                user: "အသုံးပြုသူ",
                group: "အဖွဲ့",
            },
            footer: {
                title: "Mobile School ဘဝနှင့်ကိုက်ညီသော ပျော့ပြောင်းသင်ယူမှု",
                organization: "ပညာရေးဆိုင်ရာ တန်းတူညီမျှရေး ရန်ပုံငွေ",
            },
        },
    },
    lo: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "ການຮຽນຮູ້ທີ່ຍືດຫຍຸ່ນ ຕອບໂຈດຊີວິດ",
                contactUs: "ຕິດຕໍ່ເຮົາ",
                contactEmail: "ອີເມວ {{email}}",
                home: "ໜ້າຫຼັກ",
                schoolInformation: "OBEC Zero Dropout",
                language: "ພາສາ",
                changeLanguage: "ປ່ຽນພາສາ",
                aiHub: "AI Hub",
                moocHub: "MOOC Hub",
                closeAiHub: "ປິດ AI Hub",
                opensNewTab: "ເປີດໃນແຖບໃໝ່",
                languages: {
                    th: "ໄທ",
                    en: "ອັງກິດ",
                    my: "ມຽນມາ",
                    lo: "ລາວ",
                    id: "ອິນໂດເນເຊຍ",
                    ms: "ມາເລ",
                },
            },
            search: {
                placeholder: "ຄົ້ນຫາ...",
                usageCount: "{{count}} ຄັ້ງ",
                user: "ຜູ້ໃຊ້",
                group: "ກຸ່ມ",
            },
            footer: {
                title: "Mobile School ການຮຽນຮູ້ທີ່ຍືດຫຍຸ່ນ ຕອບໂຈດຊີວິດ",
                organization: "ກອງທຶນເພື່ອຄວາມສະເໝີພາບທາງການສຶກສາ",
            },
        },
    },
};

export default mergeI18nResources(commonResources, sessionExpiryResources);
